export enum Feature {
  PlayerVsPlayerByLocation = 'player_vs_player_by_location',

  // This feature is currently only relevant for Dish DDPs. This means it will likely remain as a feature flag for quite some time
  TeamSubscriptionStatus = 'team_subscription_status',

  // This feature enables the comprehensive transactions export option
  ComprehensiveTransactionsExport = 'comprehensive_transactions_export',
  // This feature allows users to link their bank accounts to Stripe and receive payouts. The Rails API payout endpoints read the same flag
  StripePayouts = 'stripe_payouts',
  // This feature enables the new 3-section game builder (Game Details, Game Setup, Game Review)
  SectionedGameBuilder = 'sectioned_game_builder',
  // This feature enables the draft → published lifecycle for games: managers can save a game as a
  // draft (inert and invisible to players) and explicitly publish it, or move a prelaunch game back to draft.
  DraftGames = 'draft_games',
}
